export default function HeroSection() {
  const scrollToQuote = () => {
    const el = document.getElementById("quote");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToServices = () => {
    const el = document.getElementById("services");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20modern%20home%20exterior%20with%20fresh%20professional%20paint%20job%20in%20warm%20neutral%20colors%2C%20well%20maintained%20landscape%20garden%2C%20sunny%20day%20with%20clear%20blue%20sky%2C%20suburban%20Southern%20California%20setting%2C%20high%20quality%20editorial%20photography%20with%20warm%20natural%20lighting&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt="Beautiful painted home exterior"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-20 pt-28">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-accent-500/90 text-background-50 px-4 py-1.5 rounded-full text-xs font-medium tracking-wider uppercase mb-6">
            <i className="ri-star-fill text-accent-300"></i>
            Licensed #1150059 | Bonded & Insured
          </div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-medium text-background-50 leading-tight mb-6">
            Professional Painting
            <br />
            <span className="text-accent-400">Services You Can Trust</span>
          </h1>

          <p className="text-base md:text-lg text-background-200/90 max-w-xl leading-relaxed mb-8">
            Serving Corona and surrounding counties with expert interior and
            exterior painting, repairs, and surface preparation. Quality
            craftsmanship backed by years of experience.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={scrollToQuote}
              className="bg-primary-500 text-background-50 px-7 py-3.5 rounded-full text-sm font-medium tracking-wider uppercase hover:bg-primary-600 transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              Get a Free Quote
              <span className="w-8 h-8 rounded-full border border-background-50/40 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </button>
            <button
              onClick={scrollToServices}
              className="bg-background-50/10 backdrop-blur-sm text-background-50 border border-background-50/30 px-7 py-3.5 rounded-full text-sm font-medium tracking-wider uppercase hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Explore Services
            </button>
          </div>

          <div className="flex items-center gap-6 mt-10 text-sm text-background-300">
            <div className="flex items-center gap-2">
              <i className="ri-phone-line text-accent-400"></i>
              <a
                href="tel:9514792556"
                className="hover:text-accent-400 transition-colors"
              >
                (951) 479-2556
              </a>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-line text-accent-400"></i>
              <span>Corona, CA</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}